export default "__VITE_ASSET__$mJwMELh__"